export const PRIV = {
  // Dashboard
  VIEW_DASHBOARD: "VIEW_DASHBOARD",

  // Users
  VIEW_USERS: "VIEW_USERS",
  CREATE_USERS: "CREATE_USERS",
  UPDATE_USERS: "UPDATE_USERS",
  DELETE_USERS: "DELETE_USERS",
  VERIFY_USERS: "VERIFY_USERS",

  // feedbacks
  VIEW_FEEDBACKS: "VIEW_FEEDBACKS",
  DELETE_FEEDBACKS: "DELETE_FEEDBACKS",

  // Roles
  VIEW_ROLES: "VIEW_ROLES",
  CREATE_ROLES: "CREATE_ROLES",
  UPDATE_ROLES: "UPDATE_ROLES",
  DELETE_ROLES: "DELETE_ROLES",
  ASSIGN_PRIVILEGES: "ASSIGN_PRIVILEGES",

  // Privileges
  VIEW_PRIVILEGES: "VIEW_PRIVILEGES",
  CREATE_PRIVILEGES: "CREATE_PRIVILEGES",
  UPDATE_PRIVILEGES: "UPDATE_PRIVILEGES",
  DELETE_PRIVILEGES: "DELETE_PRIVILEGES",

  // Assigning roles
  ASSIGN_ROLES: "ASSIGN_ROLES",

  // Profile
  UPDATE_PROFILE: "UPDATE_PROFILE",

  // Donations
  VIEW_DONATIONS: "VIEW_DONATIONS",
  DELETE_DONATIONS: "DELETE_DONATIONS",

  // Donation Purposes
  VIEW_PURPOSES: "VIEW_DONATION_PURPOSES",
  CREATE_PURPOSES: "CREATE_DONATION_PURPOSES",
  UPDATE_PURPOSES: "UPDATE_DONATION_PURPOSES",
  DELETE_PURPOSES: "DELETE_DONATION_PURPOSES",

  // Credits
  VIEW_CREDITS: "VIEW_CREDITS",
  DELETE_CREDITS: "DELETE_CREDITS",
  ISSUE_CREDIT: "ISSUE_CREDIT",

  // Credit Applications
  VIEW_APPLICATIONS: "VIEW_APPLICATIONS",
  DELETE_APPLICATIONS: "DELETE_APPLICATIONS",
  APPROVE_APPLICATIONS: "APPROVE_APPLICATIONS",

  // Tasks
  VIEW_TASKS: "VIEW_TASKS",
  CREATE_TASKS: "CREATE_TASKS",
  UPDATE_TASKS: "UPDATE_TASKS",
  DELETE_TASKS: "DELETE_TASKS",
  COMPLETE_TASKS: "COMPLETE_TASKS",

  // API Keys
  VIEW_APIKEYS: "VIEW_APIKEYS",
  UPDATE_APIKEYS: "UPDATE_APIKEYS",
  DELETE_APIKEYS: "DELETE_APIKEYS",

  // Client IDs
  VIEW_CLIENTIDS: "VIEW_CLIENTIDS",
  UPDATE_CLIENTIDS: "UPDATE_CLIENTIDS",
  DELETE_CLIENTIDS: "DELETE_CLIENTIDS",

  // rate limit events
  VIEW_RATE_LIMITS: "VIEW_RATE_LIMITS",

  // Security Questions
  VIEW_SECURITY_QUESTIONS: "VIEW_SECURITY_QUESTIONS",
  CREATE_QUESTIONS: "CREATE_SECURITY_QUESTIONS",
  UPDATE_QUESTIONS: "UPDATE_SECURITY_QUESTIONS",
  DELETE_QUESTIONS: "DELETE_SECURITY_QUESTIONS",

  MANAGE_APIS: "MANAGE_APIS",
  MANAGE_LOCATION_RESTRICTIONS: "MANAGE_LOCATION_RESTRICTIONS",

  // message templates
  VIEW_TEMPLATES: "VIEW_TEMPLATES",
  CREATE_TEMPLATES: "CREATE_TEMPLATES",
  DELETE_TEMPLATES: "DELETE_TEMPLATES",
  UPDATE_TEMPLATES: "UPDATE_TEMPLATES",

  VIEW_HEALTH_CHECKS: "VIEW_HEALTH_CHECKS",
  CREATE_HEALTH_CHECKS: "CREATE_HEALTH_CHECKS",
  DELETE_HEALTH_CHECKS: "DELETE_HEALTH_CHECKS",
  UPDATE_HEALTH_CHECKS: "UPDATE_HEALTH_CHECKS",
  PROBE_HEALTH_CHECKS: "PROBE_HEALTH_CHECKS",
  MANAGE_HEALTH_CHECKS: "MANAGE_HEALTH_CHECKS",

  VIEW_CHARGES: "VIEW_CHARGES",
  ADD_CHARGES: "ADD_CHARGES",
  UPDATE_CHARGES: "UPDATE_CHARGES",
  VIEW_PAYOUTS: "VIEW_PAYOUTS",

  VIEW_AGREEMENTS: "VIEW_AGREEMENTS",
  ADD_AGREEMENTS: "ADD_AGREEMENTS",
  VIEW_ACTIVE_AGREEMENT: "VIEW_ACTIVE_AGREEMENT",
  EDIT_AGREEMENTS: "EDIT_AGREEMENTS",
  CHANGE_STATUS_USERAGREEMENT: "CHANGE_STATUS_USERAGREEMENT",

  VIEW_APPVERSIONS: "VIEW_APPVERSIONS",
  DELETE_APPVERSIONS: "DELETE_APPVERSIONS",
  UPDATE_APPVERSIONS: "UPDATE_APPVERSIONS",
  CREATE_APPVERSIONS: "CREATE_APPVERSIONS",

  //feature dials
  MANAGE_FEATURE_DIALS: "MANAGE_FEATURE_DIALS",
  VIEW_FEATURE_DIAL: "VIEW_FEATURE_DIAL",
  DELETE_FEATURE_DIAL: "DELETE_FEATURE_DIAL",
  UPDATE_FEATURE_DIAL: "UPDATE_FEATURE_DIAL",

  // notification topics
  VIEW_NOTIFICATION_TOPICS: "VIEW_NOTIFICATION_TOPICS",
  CREATE_NOTFICATION_TOPICS: "CREATE_NOTFICATION_TOPICS",
  DELETE_NOTFICATION_TOPICS: "DELETE_NOTFICATION_TOPICS",
  UPDATE_NOTFICATION_TOPICS: "UPDATE_NOTFICATION_TOPICS",

  // apps
  MANAGE_APPLICATIONS: "MANAGE_APPLICATIONS",

  // help requests
  VIEW_HELP_REQUESTS: "VIEW_HELP_REQUESTS",
  UPDATE_HELP_REQUESTS: "UPDATE_HELP_REQUESTS",

  MANAGE_QR_CODES: "MANAGE_QR_CODES"
};
